import useCache from "@hooks/useCache";
import useCacheKey from "@hooks/useCacheKey";
import useClerkUser from "@hooks/useClerkUser";
import { type ConsentData, useGlobalStore } from "@hooks/useGlobalStore";
import { useEffect } from "react";

const defaultConsentData: ConsentData = {
	privacy_notice: undefined,
	mobile_app_terms: undefined,
	ai_tool_terms: undefined,
	marketing_emails: undefined,
};

export const ConsentProvider = ({
	children,
}: { children: React.ReactNode }) => {
	const { isSignedIn } = useClerkUser();
	const { consentCacheKey } = useCacheKey();
	const pendingConsent = useGlobalStore((state) => state.pendingConsent);
	const setPendingConsent = useGlobalStore((state) => state.setPendingConsent);

	const { setCache } = useCache<ConsentData>({
		key: consentCacheKey || "",
		defaultData: defaultConsentData,
		enabled: !!consentCacheKey && isSignedIn,
		staleTime: 0,
		shouldInvalidate: true,
		shouldOptimisticUpdate: true,
	});

	useEffect(() => {
		if (isSignedIn && consentCacheKey && pendingConsent) {
			setCache(pendingConsent).finally(() => {
				setPendingConsent(undefined);
			});
		}
	}, [
		isSignedIn,
		consentCacheKey,
		pendingConsent,
		setCache,
		setPendingConsent,
	]);

	return <>{children}</>;
};
